import { get } from 'svelte/store';
import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
import { format } from 'svelte-i18n';
// Helpers
import { isPill, isProCover, real_id } from 'src/helpers/interface_helpers';
import { devices } from 'src/stores/lists/devices';
import { isCombinationDeviceLightMode } from './local_action_components_helpers';
import { isProSensorAddon } from 'src/helpers/addons/addon_support_helpers';
import {
	isXT1ComponentDevice,
	isXT1Module,
	resolveXT1ComponentChannel,
} from 'src/helpers/xt1_helpers/template_helpers';
//Types
import type { SelectOptionPropsType } from '@Shelly/shelly-design-system/index';
import type { Device } from 'src/types/Device';

export type TargetSelectOption = SelectOptionPropsType & {
	componentId?: number;
};

export const getTargetOptions = (device: Device): TargetSelectOption[] => {
	const $format = get(format);
	const allDevices = get(devices);
	const deviceId = real_id(device.id);
	const settings = readDeviceSettings(deviceId);
	let channelsOptions: TargetSelectOption[];
	if (isXT1Module(device.type)) {
		channelsOptions = Object.values(allDevices)
			.filter(
				(channelDevice: Device) =>
					real_id(channelDevice.id) === deviceId && isXT1ComponentDevice(channelDevice),
			)
			.map((channelDevice: Device) => ({
				title: channelDevice.name,
				value: channelDevice.id,
				componentId: resolveXT1ComponentChannel(channelDevice).channel,
			}));
	} else if (
		!isCombinationDeviceLightMode(device) &&
		device.channels_count > 1 &&
		device.category != 'emeter' &&
		(device.category !== 'roller' || isProCover(device.type)) //Pro2Cover
	) {
		channelsOptions = [
			{
				title: allDevices[deviceId].name,
				value: allDevices[deviceId].channel,
			},
		];
		for (let i = 1; i < device.channels_count; ++i) {
			if (allDevices[`${deviceId}_${i}`]) {
				channelsOptions.push({
					title: allDevices[`${deviceId}_${i}`].name,
					value: allDevices[`${deviceId}_${i}`].channel,
				});
			}
		}
	}
	if (device.type === 'SPEM-002CEBEU50' || isPill(device.type)) {
		channelsOptions = [];
		Object.keys(settings || {})
			.filter((key) => key.match(/switch:\d+/))
			.sort()
			.forEach((key) => {
				const switchAddon = settings[key];
				const channel = switchAddon.id;
				channelsOptions.push({
					title:
						switchAddon.name ||
						$format('local_action_control_output', {
							default: 'Control Output',
						}) + ` (${channel})`,
					value: channel,
				});
			});
	} else if (isProSensorAddon(device)) {
		if (!channelsOptions?.length) {
			channelsOptions = [
				{
					title: allDevices[deviceId].name,
					value: allDevices[deviceId].channel,
				},
			];
		}
		Object.keys(settings || {})
			.filter((key) => key.match(/^switch:\d{3}$/))
			.sort()
			.forEach((key) => {
				const switchAddon = settings[key];
				const channel = switchAddon.id;
				channelsOptions.push({
					title:
						switchAddon.name ||
						$format('local_action_control_output', {
							default: 'Control Output',
						}) + ` (${channel})`,
					value: channel,
				});
			});
	}
	return channelsOptions;
};
